import { FC } from 'react';
import { Link, LinkProps, useMatch, useResolvedPath } from 'react-router-dom';

interface NavTabLinkProps extends LinkProps {
    children: any | ((isActive: boolean) => any);
    to: string;
}

const NavTabLink: FC<NavTabLinkProps> = (props) => {
    const { to, children, className, ...rest } = props;

    const resolved = useResolvedPath(to);
    const match = useMatch({ path: resolved.pathname, end: true });

    return (
        <Link {...rest} aria-current={match ? 'page' : undefined} className={className} to={to} replace>
            {typeof children === 'function' ? children(Boolean(match)) : children}
        </Link>
    );
};

export default NavTabLink;
